import type {KeyValue} from '../../../../../utils/object'
import type {NewPipeline, Pipeline} from '../../services/pipelinesApi.types'
import type {ValidationErrorMessage} from '../../utils/validators.types'

type PipelineDraft = {
  original?: Pipeline
  draft?: NewPipeline
  isCollisionApi?: boolean
  deleted?: {
    jobs?: string[]
    parameters?: string[]
    steps?: Record<string, number[]>
    integrations?: string[]
    secrets?: string[]
  }
  renamed?: {
    jobs?: Record<string, string>
    parameters?: Record<string, string>
    integrations?: Record<string, string>
    secrets?: Record<string, string>
  }
  reordered?: {
    steps?: Record<string, number[]>
  }
}

export type PipelineDraftState = KeyValue<string, PipelineDraft>

export type PipelineValidationErrorMessage = ValidationErrorMessage & {
  jobId?: string
}

export type PipelineErrorState = {
  errors: PipelineValidationErrorMessage[]
}

export enum FormType {
  PIPELINE_INTEGRATION = 'pipelineIntegration',
}

export type PipelineFormState = {
  id?: string
  type?: FormType
  isOpened?: boolean
  data?: unknown
}
